import apiClient from '@u/apiClient'

export default {
  async fetchLanguages({ commit, getters }, local) {
    await apiClient
      .get('/api/locales/languages')
      .then(async (response) => {
        // await commit('setTranslations', response.data.translations)
      })
      .catch(async (reason) => {
        console.error('fetchLanguages', reason)
      })
  }
}
